(() => {!function(){
  if(!window.klaviyo){
    window._klOnsite=window._klOnsite||[];
    try{
      window.klaviyo=new Proxy({},{
        get:function(n,i){
          return"push"===i
            ?function(){
              var n;
              (n=window._klOnsite).push.apply(n,arguments)
            }
            :function(){
              for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)
                o[w]=arguments[w];
              var t="function"==typeof o[o.length-1]?o.pop():void 0,
              e=new Promise(function(n){
                window._klOnsite.push([i].concat(o,[function(i){
                  t&&t(i),n(i)
                }]))
              });
              return e
            }
        }
      })
    }catch(n){
      window.klaviyo=window.klaviyo||[],
      window.klaviyo.push=function(){
        var n;
        (n=window._klOnsite).push.apply(n,arguments)
      }
    }
  }
}();
  if (window.__calestroCartKlaviyoSync) return;
  window.__calestroCartKlaviyoSync = true;

  const nativeFetch = window.fetch.bind(window);

  let syncTimer1;
  let syncTimer2;

  function isCartMutation(url) {
    if (!url) return false;

    return /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/i.test(
      String(url)
    );
  }

  function cartUrl() {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return root + "cart.js";
  }

  async function syncCartToKlaviyo() {
    try {
      const response = await nativeFetch(cartUrl(), {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) return;

      const cart = await response.json();
      const itemCount = Number(cart.item_count || 0);
const cartItems = (cart.items || []).map((item) => ({
  title: item.product_title || item.title || "",
  variant: item.variant_title || "",
  quantity: Number(item.quantity || 1),
  price: new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: cart.currency || "TRY",
  }).format(Number(item.final_price || item.price || 0) / 100),
  image: item.image || "",
  url: item.url ? window.location.origin + item.url : "",
}));
     const item1 = cartItems[0] || {};
const item2 = cartItems[1] || {};
const item3 = cartItems[2] || {};

const properties = {
  CartItemCount: itemCount,
  CartHasItems: itemCount > 0,

  CartProduct1Title: item1.title || "",
  CartProduct1Variant: item1.variant || "",
  CartProduct1Price: item1.price || "",
  CartProduct1Image: item1.image || "",
  CartProduct1Url: item1.url || "",

  CartProduct2Title: item2.title || "",
  CartProduct2Variant: item2.variant || "",
  CartProduct2Price: item2.price || "",
  CartProduct2Image: item2.image || "",
  CartProduct2Url: item2.url || "",

  CartProduct3Title: item3.title || "",
  CartProduct3Variant: item3.variant || "",
  CartProduct3Price: item3.price || "",
  CartProduct3Image: item3.image || "",
  CartProduct3Url: item3.url || "",

  CartUpdatedAt: new Date().toISOString(),
};

      if (
        window.klaviyo &&
        typeof window.klaviyo.identify === "function"
      ) {
        await window.klaviyo.identify(properties);
      } else if (
        window.klaviyo &&
        typeof window.klaviyo.push === "function"
      ) {
        window.klaviyo.push(["identify", properties]);
      }
    } catch (error) {
      console.warn("[Calestro] Cart sync failed:", error);
    }
  }

  function scheduleCartSync() {
    clearTimeout(syncTimer1);
    clearTimeout(syncTimer2);

    syncTimer1 = setTimeout(syncCartToKlaviyo, 700);
    syncTimer2 = setTimeout(syncCartToKlaviyo, 1800);
  }

  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);

    try {
      const input = args[0];
      const url =
        typeof input === "string"
          ? input
          : input && input.url
          ? input.url
          : "";

      if (isCartMutation(url)) {
        scheduleCartSync();
      }
    } catch (error) {}

    return response;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__calestroCartMutation = isCartMutation(url);
    return nativeOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this.__calestroCartMutation) {
      this.addEventListener("loadend", scheduleCartSync, {
        once: true,
      });
    }

    return nativeSend.apply(this, args);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncCartToKlaviyo, {
      once: true,
    });
  } else {
    syncCartToKlaviyo();
  }
})();